export const ONE_TWO_THREE_LOADBOARD_AUTH_URI = process.env.ONE_TWO_THREE_LOADBOARD_AUTH_URI;
export const CLIENT_ID = process.env.ONE_TWO_THREE_LOADBOARD_CLIENT_ID;
export const SCOPE = 'loadsearching';
export const REDIRECT_URI = `${window.location.origin}/driver/connect/123loadboard`;
export const RESPONSE_TYPE = 'code';
export const RESOURCE = process.env.ONE_TWO_THREE_LOADBOARD_RESOURCE_ID;
